import React, {Component} from 'react'

import Header from '../components/Header/header';
import HeroSection from '../components/HeroSection';
import PromoSection from '../components/PromoSection';
import AboutSection from '../components/AboutUs';
import ServiceSection from '../components/Service';
import Pricing from '../components/Pricing';
import Testimonial from '../components/Testimonial';
import Contact from '../components/Contact';
import ActionToCall from '../components/ActionToCall';
import Footer from '../components/footer/footer';


class ThemeOne extends Component{
    render(){
        return(
            <div>
                <Header />
                <div className="main">
                    <HeroSection />
                    <PromoSection />
                    <AboutSection />
                    <ServiceSection />
                    <Pricing />
                    <Testimonial />
                    <Contact />
                    <ActionToCall />
                </div>
                <Footer />
            </div>
        )
    }
}

export default ThemeOne